var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-wrapper community-tickets"},[_c('table-tickets')],1)}
var staticRenderFns = []

export { render, staticRenderFns }